/**
 * Typed fetchers for Create → Translate. The run itself is a solution run of
 * kind `translate` (`createRun` in `solutionRuns.ts`); this module serves what
 * the new-run form offers.
 *
 * Types come from the OpenAPI-generated schema. Regenerate via `pnpm gen:api`
 * after a backend Pydantic change.
 */

import type { components } from "./_generated/schema";
import { apiFetch } from "./apiFetch";

export type TranslationOptionsOut = components["schemas"]["TranslationOptionsOut"];
export type TranslationLanguageOut = components["schemas"]["TranslationLanguageOut"];

/** Translator's supported languages, the collection formats Document
 *  Translation accepts, and the size cap. `available: false` when this
 *  environment has no Translator. `502 upstream_error` if Translator fails. */
export function getTranslateOptions(token: string): Promise<TranslationOptionsOut> {
  return apiFetch<TranslationOptionsOut>("/api/v1/solutions/translate/options", { token });
}
